import React from 'react';

import { getUserDetails } from "../data/data";
import { AuthContext } from "../../authContext";
import Loading from "../shared/Loading";
import BiodiversityNetGain from "./biodiversity/BiodiversityNetGain";
import UrbanContext from "./urban-context/UrbanContext";

const analysisModuleMappings = {
    "biodiversity-net-gain": <BiodiversityNetGain />,
    "urban-context": <UrbanContext />
}

class Analysis extends React.Component {
    state = {
        isLoading: true,
        userDetails: {}
    }
    static contextType = AuthContext;
    componentDidMount() {
        if (this.context.isLoggedIn === false)
            this.context.navigate('/');
        else {
            if (this.context.userDetails.token !== "") {
                this.getUserDetailsAsync();
            }
        }
    }
    getUserDetailsAsync = async () => {
        const userDetails = await getUserDetails(this.context.userDetails.token);
        this.setState({
            userDetails: userDetails.data,
            isLoading: false
        });
    }

    render() {
        if (this.state.isLoading)
            return (<Loading/>);
        else
            return analysisModuleMappings[this.props.match.params.id];
    }

}

export default Analysis;